import tw, { styled } from 'twin.macro';
import Icon from '@/components/Icon/IconAsset';

export const StyledComparisonCard = styled.div`
  ${tw`flex flex-col`}
  ${tw`justify-between`}
  ${tw`p-3 sm:p-4`}
  ${tw`border-2 border-ui-colours-ui3 `}
  ${tw`rounded-xl`}
  ${tw`text-primary-p1`}
`;

export const StyledHeader = styled.header`
  ${tw`flex gap-2 flex-col md:flex-row`}
  ${tw`mb-[22px]`}
`;

export const StyledIcon = styled(Icon)`
  ${tw`w-[64px] h-[64px]`}
`;
export const StyledHeadline = styled.h1`
  ${tw`text-mobile-heading-m md:text-heading-m text-secondary-s1`}
  ${tw`font-poppins font-semi-bold`}
`;
export const StyledSubheadline = styled.p`
  ${tw`text-mobile-heading-xxs md:text-heading-xxs`}
  ${tw`font-poppins font-semi-bold`}
`;

export const StyledBody = styled.div`
  ${tw`mb-[34px]`}

  & p {
    ${tw`mb-[29px]`}
    ${tw`text-body-m`}
  }

  & ul li {
    background: url('/assets/check.svg') no-repeat left top;
    ${tw`py-[5px] pl-[36px]`}
    ${tw`not-first-of-type:mt-1`}
    ${tw`text-body-s`}
    ${tw`font-inter`}
  }
`;

export const StyledCTAs = styled.div<{ hasBothCTAs: boolean }>`
  ${tw`grid`}
  ${tw`gap-2 sm:gap-3`}

  ${({ hasBothCTAs }) => hasBothCTAs && tw`lg:grid-cols-2`}
`;
